/**
 * Small collection of components used in multiple steps.
 *
 * This is *only* for styling default MUI components,
 * do not put anything with logic in here.
 */
import PropTypes from 'prop-types';
import React from 'react';
import {ArrowForwardIosSharp as ArrowForwardIosSharpIcon} from '@mui/icons-material';
import {
  Box,
  DialogContent,
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  Paper,
  TextField,
} from '@mui/material';

export const Sidebar = props => (
  <Box
    display="flex"
    flexDirection="column"
    borderLeft="1px solid"
    borderColor="divider"
    width="40%"
    sx={{
      backgroundColor: theme =>
        theme.palette.mode === 'dark'
          ? theme.palette.grey[800]
          : theme.palette.grey[100],
    }}
    {...props}
  />
);

export const MapPanel = props => (
  <Box
    padding={1}
    height="100%"
    width="60%"
    flexShrink={0}
    flexGrow={0}
    maxHeight={600}
    {...props}
  />
);

export const FormField = props => (
  <TextField
    size="small"
    margin="normal"
    InputLabelProps={{
      shrink: true,
    }}
    component={Paper}
    elevation={0}
    {...props}
  />
);

export const Content = ({sx, ...props}) => (
  <DialogContent
    sx={[{padding: 0, display: 'flex'}, ...(Array.isArray(sx) ? sx : [sx])]}
    {...props}
  />
);

Content.propTypes = {
  sx: PropTypes.object,
};

export const Accordion = ({sx, ...props}) => (
  <MuiAccordion
    disableGutters
    elevation={0}
    square
    sx={[
      {
        borderBottom: theme => `1px solid ${theme.palette.divider}`,
        '&::before': {
          display: 'none',
        },
        backgroundColor: 'transparent',
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
    {...props}
  />
);

Accordion.propTypes = {
  sx: PropTypes.object,
};

export const AccordionSummary = ({sx, ...props}) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{fontSize: '0.9rem'}} />}
    sx={[
      {
        paddingX: 1,
        backgroundColor: theme =>
          theme.palette.mode === 'dark'
            ? theme.palette.grey[800]
            : theme.palette.grey[100],
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
          transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content, .MuiAccordionSummary-content.Mui-expanded':
          {
            marginLeft: 0.5,
          },
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
    {...props}
  />
);

AccordionSummary.propTypes = {
  sx: PropTypes.object,
};

export const AccordionDetails = props => (
  <MuiAccordionDetails
    sx={{
      backgroundColor: theme =>
        theme.palette.mode === 'dark'
          ? theme.palette.grey[800]
          : theme.palette.grey[100],
      borderTop: '1px solid rgba(0, 0, 0, .125)',
    }}
    {...props}
  />
);
